export default __webpack_public_path__ + "static/media/996.e564ee67.gif";